module.exports = __webpack_public_path__ + "iPhone7-JetBlack-landscape.png?16aba5f105e13ac4bb69bff7a97691ab";